/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { Record } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import LocalDate from '../../domain/type/Date'
import ReportCheckInEvent from '../../event/MonthlyReportEvent'

const ReportCheckInSearchState = Record({
  search_date: LocalDate.today().beginningOfMonth(),
  search_hotel_id: null
})

class ReportCheckInSearchStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new ReportCheckInSearchState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case ReportCheckInEvent.onEditCheckIn:
        return state.set(payload.name, payload.value)
      default:
        return state
    }
  }
}

export default new ReportCheckInSearchStore()
